import React, { useEffect, useRef, useState } from "react";
import Counter from "./Counter";
import API from "../api/Api";

export default function ImpactNumbers() {
  const sectionRef = useRef(null);
  const [startCounter, setStartCounter] = useState(false);
  const [impactData, setImpactData] = useState([]);

  // 🔹 Fetch all impact counters
useEffect(() => {
  API.get("/impact_counter")
    .then((res) => {
      const apiData = res.data.data;

      // ✅ ALWAYS convert to array
      const normalizedData = Array.isArray(apiData)
        ? apiData
        : [apiData];

      setImpactData(normalizedData);
    })
    .catch((err) => {
      console.error("Impact Counter API Error", err);
    });
}, []);


  // 🔹 Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setStartCounter(entry.isIntersecting),
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="impact-section" ref={sectionRef}>
      <div className="container-fluid">
        <div className="impact-box">

          <h2 className="impact-title">Our Impact in Numbers</h2>
          <p className="impact-subtitle">
            Driving measurable change across India
          </p>

          <div className="row impact-stats gy-4">

            {impactData.slice(0, 4).map((item, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="impact-item">
                  <Counter
                    end={Number(item.impact_numbers_value)}
                    start={startCounter}
                  />
                  <div className="impact-label">
                    {item.impact_numbers_key}
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
}
